/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Status_ConnectingInputs */



/**
* | output |
* | --- |
* | "Connecting to Iconik..." |
*
* @param {Iconik_Proxy_Status_ConnectingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_status_connecting = /** @type {((inputs?: Iconik_Proxy_Status_ConnectingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Status_ConnectingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connexion a Iconik...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbindung zu Iconik wird hergestellt...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Connessione a Iconik...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подключение к Iconik...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conectando a Iconik...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在连接到 Iconik...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Iconik に接続しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Iconik से कनेक्ट हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conectando-se à Iconik...")
	return /** @type {LocalizedString} */ ("Connecting to Iconik...")
});